export default __webpack_public_path__ + "static/media/emailSVG.7fb581f4.svg";